// extracted by mini-css-extract-plugin
module.exports = {"form":"DoctorManagement_form__11usf"};